import { useMemo } from 'react';
import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { DefaultBrandVoiceChannel } from '../constants/BrandVoice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BrandVoiceTooltipHeader = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h4",
      typography: "heading-100",
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "brandVoice.header"
      })
    }), /*#__PURE__*/_jsx(AIBadge, {})]
  });
};
const BrandVoiceTooltipContent = ({
  voiceChannel,
  voiceData = {
    tone: [],
    personality: []
  },
  hydratedBrandSettingsUrl
}) => {
  const {
    tone,
    personality
  } = voiceData;
  const translatedTones = useMemo(() => tone.map(thisTone => unescapedText(`brandVoice.tone.${thisTone}`)), [tone]);
  const translatedPersonalities = useMemo(() => personality.map(thisPersonality => unescapedText(`brandVoice.personality.${thisPersonality}`)), [personality]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Text, {
      children: [/*#__PURE__*/_jsxs("strong", {
        children: [unescapedText('brandVoice.personalityLabel'), ": "]
      }), I18n.formatList(translatedPersonalities)]
    }), /*#__PURE__*/_jsxs(Text, {
      paddingBlockEnd: "300",
      children: [/*#__PURE__*/_jsxs("strong", {
        children: [unescapedText('brandVoice.toneLabel'), ": "]
      }), I18n.formatList(translatedTones)]
    }), /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `brandVoiceMessage.${voiceChannel || DefaultBrandVoiceChannel}.toolTip_jsx`,
        elements: {
          Link
        },
        options: {
          external: true,
          href: hydratedBrandSettingsUrl
        }
      })
    })]
  });
};
const BrandVoiceHelpIcon = ({
  children,
  voiceChannel,
  voiceData,
  hydratedBrandSettingsUrl
}) => {
  return /*#__PURE__*/_jsx(HelpIcon, {
    title: /*#__PURE__*/_jsx(BrandVoiceTooltipContent, {
      voiceData: voiceData,
      voiceChannel: voiceChannel,
      hydratedBrandSettingsUrl: hydratedBrandSettingsUrl
    }),
    tooltipProps: {
      headingText: /*#__PURE__*/_jsx(BrandVoiceTooltipHeader, {}),
      use: 'longform'
    },
    children: children
  });
};
export const BrandVoicePopover = ({
  children,
  voiceChannel,
  voiceData,
  hydratedBrandSettingsUrl,
  open,
  onOpenChange
}) => {
  return /*#__PURE__*/_jsx(Popover, {
    content: {
      header: /*#__PURE__*/_jsx(Flex, {
        marginBlockEnd: "200",
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(BrandVoiceTooltipHeader, {})
      }),
      body: /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: "500",
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(BrandVoiceTooltipContent, {
          voiceData: voiceData,
          voiceChannel: voiceChannel,
          hydratedBrandSettingsUrl: hydratedBrandSettingsUrl
        })
      })
    },
    open: open,
    onOpenChange: onOpenChange,
    placement: "left bottom",
    use: "longform",
    children: children
  });
};
export default BrandVoiceHelpIcon;